import { useQuery } from '@tanstack/react-query';
import { PlaylistApi } from './PlaylistApi';
import { PLAYLIST_QUERY_KEYS } from '@/lib/constants/playlist';
import { useAuth } from '@/features/auth/hooks/useAuth';
import type { ListType } from '@/lib/constants/playlist';
import type { AnyPlaylistView, CustomPlaylistView, TagPlaylistView } from '@/lib/types/Playlist';

export function usePlaylist(listId: number, listType: ListType | null) {
  const { selectedCId } = useAuth();

  const isCustom = listType === 'custom';
  const queryKey = isCustom
    ? PLAYLIST_QUERY_KEYS.customDetail(selectedCId ?? 0, listId)
    : PLAYLIST_QUERY_KEYS.tagDetail(selectedCId ?? 0, listId);

  const query = useQuery<AnyPlaylistView>({
    queryKey,
    queryFn: async (): Promise<AnyPlaylistView> => {
      if (isCustom) {
        return PlaylistApi.getCustomPlaylist(selectedCId!, listId);
      }
      return PlaylistApi.getTagPlaylist(selectedCId!, listId);
    },
    enabled: selectedCId != null && listId > 0 && listType != null,
    staleTime: 2 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  return {
    playlist: query.data as CustomPlaylistView | TagPlaylistView | undefined,
    isLoading: query.isLoading || listType == null,
    isError: query.isError,
    error: query.error,
  };
}
